import Bridge from "../../app/utils/Bridge";
import { RESEARCH_TYPE } from "../../app/utils/consts";

// Action Types
export const FETCH_LANGUAGE_REQUEST = "FETCH_LANGUAGE_REQUEST";
export const FETCH_LANGUAGE_SUCCESS = "FETCH_LANGUAGE_SUCCESS";
export const FETCH_LANGUAGE_FAILURE = "FETCH_LANGUAGE_FAILURE";
export const SET_LANGUAGE_LOADED = "SET_LANGUAGE_LOADED";
export const SET_LANGUAGE = "SET_LANGUAGE";

// Action Creators
export const fetchLanguage = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_LANGUAGE_REQUEST });
    if (RESEARCH_TYPE === "LE Study") {
      let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
      Bridge.participants.le_study
        .get_le_study_language(params)
        .then((res) => {
          if (res.status === 1) {
            dispatch({
              type: FETCH_LANGUAGE_SUCCESS,
              payload: res.data,
            });
          } else {
            dispatch({
              type: FETCH_LANGUAGE_SUCCESS,
              payload: "English",
            });
          }          
          dispatch({ type: SET_LANGUAGE_LOADED, payload: true });
        })
        .catch((err) => {
          dispatch({
            type: FETCH_LANGUAGE_SUCCESS,
            payload: "English",
          });
          dispatch({ type: SET_LANGUAGE_LOADED, payload: true });
        });
    } else {
      dispatch({ type: SET_LANGUAGE_LOADED, payload: true });
    }
  };
};

// Action Creator to set language directly
export const setLanguage = (language) => {
  return {
    type: SET_LANGUAGE,
    payload: language,
  };
};

